import React from 'react';
import { Send, Loader2, X, AlertCircle } from 'lucide-react';

const ChatInput = ({
  question,
  setQuestion,
  onSubmit,
  onCancel,
  isStreaming,
  isLoadingConversation,
  tokenLoading,
  tokenError,
  advertiserToken,
  disabled = false
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  const isDisabled = disabled || isStreaming || isLoadingConversation || !question.trim() || tokenLoading || !advertiserToken;

  return (
    <div className="p-4">
      <div className="max-w-4xl mx-auto">
        {/* Token Error - Only show if critical */}
        {tokenError && !tokenLoading && !advertiserToken && (
          <div className="mb-3 p-2 bg-orange-50 border border-orange-200 rounded text-xs text-orange-700 text-center">
            {tokenError}. Configure advertisers to enable the chatbot.
          </div>
        )}

        {/* Input Container - ChatGPT Style */}
        <div className="relative flex items-center gap-2 bg-white border border-gray-300 rounded-xl shadow-sm hover:shadow-md transition-shadow p-2">
          <input
            type="text"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Message Analytics AI..."
            className="flex-1 px-3 py-2 bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400"
            disabled={isStreaming || isLoadingConversation || tokenLoading}
          />

          {isStreaming && onCancel ? (
            <button
              onClick={onCancel}
              className="p-2 text-gray-500 hover:text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
              title="Stop"
            >
              <X className="w-5 h-5" />
            </button>
          ) : (
            <button
              onClick={onSubmit}
              disabled={isDisabled}
              className="p-2 rounded-lg transition-all disabled:opacity-40 disabled:cursor-not-allowed"
              style={{
                backgroundColor: isDisabled ? '#d1d5db' : '#1C4645',
                color: '#ffffff'
              }}
              onMouseEnter={(e) => {
                if (!isDisabled) {
                  e.currentTarget.style.opacity = '0.9';
                }
              }}
              onMouseLeave={(e) => {
                if (!isDisabled) {
                  e.currentTarget.style.opacity = '1';
                }
              }}
              title="Send"
            >
              {(isStreaming || isLoadingConversation) ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                <Send className="w-5 h-5" />
              )}
            </button>
          )}
        </div>

        {tokenLoading && (
          <div className="mt-2 text-center text-xs text-gray-500">
            <Loader2 className="w-3 h-3 animate-spin inline mr-1" />
            Initializing...
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatInput;
